export default __webpack_public_path__ + "static/media/CA.da475f4a.svg";